import { Box, Typography, LinearProgress } from 'components/ui';

const Usage = ({ value, valueBuffer, label }) => {
  const safeValue = Math.min(value, valueBuffer);
  const percentage = valueBuffer > 0 ? (safeValue / valueBuffer) * 100 : 0;

  return (
    <Box mt={2}>
      <Typography variant="body2" gutterBottom>
        {label} {safeValue} / {valueBuffer}
      </Typography>
      <LinearProgress variant="determinate" value={percentage} />
    </Box>
  );
};

export default Usage;
